// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BannerController from "./banner_controller"
application.register("banner", BannerController)

import CardTemplateEditorController from "./card_template_editor_controller"
application.register("card-template-editor", CardTemplateEditorController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ConfirmationController from "./confirmation_controller"
application.register("confirmation", ConfirmationController)

import DatatableController from "./datatable_controller"
application.register("datatable", DatatableController)

import DropdownPopoverController from "./dropdown_popover_controller"
application.register("dropdown-popover", DropdownPopoverController)

import DurationPickerController from "./duration_picker_controller"
application.register("duration-picker", DurationPickerController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FolderCarouselController from "./folder_carousel_controller"
application.register("folder-carousel", FolderCarouselController)

import FullscreenController from "./fullscreen_controller"
application.register("fullscreen", FullscreenController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import Games__BingoController from "./games/bingo_controller"
application.register("games--bingo", Games__BingoController)

import LivestreamSettingsController from "./livestream_settings_controller"
application.register("livestream-settings", LivestreamSettingsController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PhotoController from "./photo_controller"
application.register("photo", PhotoController)

import PhotoPickerController from "./photo_picker_controller"
application.register("photo-picker", PhotoPickerController)

import PhotoSelectionController from "./photo_selection_controller"
application.register("photo-selection", PhotoSelectionController)

import PinController from "./pin_controller"
application.register("pin", PinController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SlideoverController from "./slideover_controller"
application.register("slideover", SlideoverController)

import SnackbarController from "./snackbar_controller"
application.register("snackbar", SnackbarController)

import StreamController from "./stream_controller"
application.register("stream", StreamController)

import StreamPreloadController from "./stream_preload_controller"
application.register("stream-preload", StreamPreloadController)

import StreamQueueController from "./stream_queue_controller"
application.register("stream-queue", StreamQueueController)

import TriggerModalController from "./trigger_modal_controller"
application.register("trigger-modal", TriggerModalController)

import UploadController from "./upload_controller"
application.register("upload", UploadController)

import VideoController from "./video_controller"
application.register("video", VideoController)
